.list {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.item {
  min-width: var(--input-height);
  padding: var(--padding-base-y) var(--padding-base-x);
  border: 1px solid transparent;
  border-radius: var(--border-radius-base);
  background: transparent;
  color: var(--pagination-color);
  font: inherit;
  line-height: var(--line-height-base);
  text-align: center;
  cursor: pointer;
}

.item:hover:not(:disabled) {
  background: var(--pagination-hover-bg);
}

.item:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 1px;
}

.item:disabled {
  background: transparent;
  color: var(--pagination-disabled-color);
  cursor: default;
}

/* Current page keeps its highlight even while disabled (loading). */
.item[data-selected] {
  background: var(--color-primary);
  color: #fff;
  cursor: default;
}

.item[data-selected]:hover:not(:disabled) {
  background: var(--color-primary-hover);
}

.ellipsis {
  display: inline-flex;
  min-width: var(--input-height);
  justify-content: center;
  color: var(--text-muted);
}
